import { NgModule } from '@angular/core';
import { DecoratorsModule } from './decorators';

@NgModule({
  imports: [
    DecoratorsModule
  ],
  exports: [
    DecoratorsModule
  ]
})
export class NgrxLabsModule { }
